import { useEffect } from 'react';
import type { IDateState } from '../types';

/**
 * A date selection UI that sets the date to today.
 */
export const TodaySelector = ({
  setDate,
}: Partial<Pick<IDateState, 'setDate'>>) => {
  useEffect(() => {
    const today = new Date();
    setDate?.(today);
  }, [setDate]);

  //this doesn't actually display any ux, just sets the date
  return null;
};
